import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=56fb62f1&scoped=true&"
import script from "./NotificationsButton.vue?vue&type=script&lang=js&"
export * from "./NotificationsButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=56fb62f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb62f1",
  null
  
)

export default component.exports